// Main.jsx
import React, { useState, useEffect, useRef } from 'react';
import { Routes, Route } from 'react-router-dom';
import cl from './Main.module.css';
import firstUpdate from '../../store/firstUpdate'
import Menu from '../../components/Menu/Menu';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import DemoBanner from '../../components/DemoBanner/DemoBanner';
import FerstPage from '../FerstPage/FerstPage';
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop';
import useMobileDetection from '../../hooks/useMobileDetection';
import LoaderAni from '../../components/UI/LoaderAni/LoaderAni';
import Students from '../Jornal/Students';
import Student from '../Jornal/Student';
import Settings from './../Jornal/Settings';
import EditCourse from '../Jornal/EditCourse';
import EditEvent from '../Jornal/EditEvent';
import Jornal from './../Jornal/Jornal';
import Course from '../Jornal/Course';
import Pays from '../Jornal/Pays';
import Events from '../Jornal/Events';
import Event from '../Jornal/Event';
import MainJournal from '../Jornal/MainJornal';
import AccountStufents from './../Accounts/AccountStufents';
import PrepodAndAdmin from '../Accounts/PrepodAndAdmin';
import AproveProject from '../RoboTehnick/AproveProject';
import ProgressStudent from '../RoboTehnick/ProgressStudent';
import PaysAccount from '../Pays/Pays';
import Materials from '../Materials/Materials';
import Me from '../Me/Me';
import SettingsAccount from '../Me/Settings';
import Forum from '../Materials/Forum/Forum';
import CategoryTopics from './../Materials/Forum/CategoryTopics';
import TopicView from './../Materials/Forum/TopicView';
import MyTopics from '../Materials/Forum/MyTopics';
import Notes from '../Materials/Notes/Notes';
import ArticleView from '../Materials/Notes/ArticleView';
import ArticleEditor from '../Materials/Notes/ArticleEditor';
import MyArticles from '../Materials/Notes/MyArticles';
import FAQ from '../Materials/FAQ/FAQ';
import FAQCategoryView from './../Materials/FAQ/FAQCategoryView';
import FAQArticleView from './../Materials/FAQ/FAQArticleView';
import FAQEditor from './../Materials/FAQ/FAQEditor';

const Main = () => {

  const { isMobile, isLoading: mobileDetectionLoading, isStable } = useMobileDetection();
  const [isMenuExpanded, setIsMenuExpanded] = useState(true);
  // Ссылка на прокручиваемый контентный контейнер. Используется ScrollToTop,
  // чтобы при смене страницы прокрутить именно его (window сам не скроллится).
  const contentRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuExpanded(prev => !prev);
  };

  const closeMobileMenu = () => {
    if (isMobile) setIsMenuExpanded(false);
  };

  useEffect(() => {
    // На десктопе меню по умолчанию раскрыто, на мобиле — закрыто (drawer).
    setIsMenuExpanded(!isMobile);
  }, [isMobile]);

  // Запрет прокрутки body, когда drawer открыт на мобиле
  useEffect(() => {
    if (isMobile && isMenuExpanded) {
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = ''; };
    }
  }, [isMobile, isMenuExpanded]);

  if (mobileDetectionLoading || !isStable) {
    return <LoaderAni />
  }

  firstUpdate();
  return (
    <div className={`${cl.container} ${isMobile ? cl.containerMobile : ''}`}>
      <Menu
        isExpanded={isMenuExpanded}
        onToggle={toggleMenu}
        isMobile={isMobile}
        onCloseMobile={closeMobileMenu}
      />
      <div className={cl.mainContent}>
        <Header
          showMenuButton={isMobile}
          onMenuToggle={toggleMenu}
        />
        <DemoBanner />
        <ScrollToTop targetRef={contentRef}/>
        <div ref={contentRef} className={cl.contentWrapper}>
          <div className={cl.contentArea}>
            <Routes>
              <Route index element={<MainJournal />} />
              <Route path="students" element={<Students />} />
              <Route path="students/:id" element={<Student />} />
              <Route path="journal/course/:id" element={<Course />} />
              <Route path="events/event/:id" element={<Event />} />
              <Route path="jornal/settings" element={<Settings />} />
              <Route path="/edit-courses" element={<EditCourse />} />
              <Route path="/edit-events" element={<EditEvent />} />
              <Route path="/jornal" element={<Jornal />} />
              <Route path="/pays" element={<Pays />} />
              <Route path="/events" element={<Events />} />
              <Route path="/accountStudents" element={<AccountStufents />} />
              <Route path="/prepodandadmin" element={<PrepodAndAdmin />} />
              <Route path="/aproveproject" element={<AproveProject />} />
              <Route path="/progressstudent" element={<ProgressStudent />} />
              <Route path="/paysacount" element={<PaysAccount />} />
              <Route path="/materials" element={<Materials />} />
              <Route path="/me" element={<Me />} />
              <Route path="/settings" element={<SettingsAccount />} />
              <Route path="/forum" element={<Forum />} />
              <Route path="/forum/categories/:categoryId" element={<CategoryTopics />} />
              <Route path="/forum/topics/:topicId" element={<TopicView />} />
              <Route path="/forum/my-topics" element={<MyTopics />} />
              <Route path="/articles" element={<Notes />} />
              <Route path="/articles/:articleId" element={<ArticleView />} />
              <Route path="/articles/create" element={<ArticleEditor />} />
              <Route path="/articles/edit/:articleId" element={<ArticleEditor />} />
              <Route path="/articles/my" element={<MyArticles />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/faq/category/:categoryName" element={<FAQCategoryView />} />
              <Route path="/faq/articles/:articleId" element={<FAQArticleView />} />
              <Route path="/faq/create" element={<FAQEditor />} />
              <Route path="/faq/edit/:articleId" element={<FAQEditor />} />
              {/* Redirect any unknown route under /main to index1 */}
              {/* <Route path="*" element={<Navigate to="/main" replace />} /> */}
            </Routes>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Main;